import './BatchConfirmScreen.scss';

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

import { getBatch } from 'src/module/batchSchedule/selector';

import PropTypes from 'prop-types';

import Status from './Status';
import Confirm from './Confirm';
import { fetchBatchStatus } from 'src/module/batchSchedule/action';
import { fetchRecipes } from 'src/module/recipe/action';
import NotFoundScreen from 'src/screen/Error/NotFoundScreen';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function BatchConfirmScreen (props) {
  const { t } = useTranslation();
  const batchId = props.match.params.batch_id;
  const batch = useSelector(getBatch(batchId));
  const dispatch: any = useDispatch();
  const [statusFilter, setStatusFilter] = React.useState('all');

  // if no recipes then fetch them
  useEffect(() => {
    dispatch(fetchBatchStatus(batchId));
    dispatch(fetchRecipes());
  }, [batchId]);

  // Poll for live status updates while batch is active
  useEffect(() => {
    if (!batch || batch.get('completed_at')) {
      return;
    }
    const interval = setInterval(() => {
      dispatch(fetchBatchStatus(batchId));
    }, 5000);
    return () => clearInterval(interval);
  }, [batchId, batch?.get('completed_at')]);

  if (!batch) {
    return (<NotFoundScreen />);
  }

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div id='batch-confirm-screen' className='page' data-testid='grouped-devices-screen'>
      <Helmet>
        <title>{title} - {batch.get('started_at') || batch.get('scheduled_at') ? t('batchConfirm.massProgramStatus') : t('batchConfirm.confirmMassProgram')}</title>
      </Helmet>
      <div>
        {batch.get('started_at') || batch.get('scheduled_at') ? <Status statusFilter={statusFilter} setStatusFilter={setStatusFilter}/> : <Confirm statusFilter={statusFilter} setStatusFilter={setStatusFilter}/>}
      </div>
    </div>
  );
}

BatchConfirmScreen.propTypes = {
  match: PropTypes.object
};

BatchConfirmScreen.defaultProps = {};
